/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileProgression } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_007: Question = {
  id: 'multi-007-superficie-vegetation',
  oldId: '68',
  title: 'Superficie de la végétation',
  number: '6.3',
  description: ['La superficie de végétation basse inclut les prairies, friches et parcs, alors que la végétation haute inclut tous arbres urbains, boisés urbains et forêts (indice de canopée)'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data:any, values: any) => {
        if (data && data.currentYearValue && data.previousYearValue) {
          const { currentYearValue, previousYearValue } = data;

          const { superficie } = values;
          const currentYearAreaInKm2 = currentYearValue * 0.01;
          const previousYearAreaInKm2 = previousYearValue * 0.01;
          const coefficientCurrentYear = (currentYearAreaInKm2 / superficie).toFixed(2);
          const coefficientPreviousYear = (previousYearAreaInKm2 / superficie).toFixed(2);

          const difference = parseFloat(coefficientCurrentYear) - parseFloat(coefficientPreviousYear);
          if (difference > 0) return 1;
          if (difference < 0) return 0;
          if (difference === 0) return 0.5;
          return difference;
        }
        return 0;
      },
      previewFct: (data:any) => {
        if (data && data.areaVegetation && data.areaMunicipality) {
          const { areaMunicipality, areaVegetation } = data;
          return {
            value: `${(((parseInt(areaVegetation, 10) * 0.01) / areaMunicipality) * 100).toFixed(2)}%`,
            label: 'Coefficient',
          };
        }
        return { value: '0%', label: 'Coefficient' };
      },
      score: '0',
      maxScore: 1,
      compairedTo: 'multi-007-superficie-vegetation',
      help: etoileProgression,
      unit: SlotUnit.HECTARE,
    },
  ],
};

const question_multi_007__v3: Question = {
  ...question_multi_007,
  frequency: 4,
};

export const question_multi_007_v2: Question = question_multi_007;
export const question_multi_007_v3: Question = question_multi_007__v3;
